var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { PregnancyDoctorEdit, PregnancyDoctorEditBreadcrumbs, useShowToast, } from "@madmedical/ui";
import { DeleteDocumentDialog, UploadPregnancyDocModal, } from "@madmedical/document";
import { useRouteNavigate } from "@madmedical/user";
import { useUpsertPregnancyMutation } from "../api";
import PregnancyDataProviderWrapper from "./PregnancyDataProviderWrapper";
var ModalMode;
(function (ModalMode) {
    ModalMode[ModalMode["Closed"] = 0] = "Closed";
    ModalMode[ModalMode["Delete"] = 1] = "Delete";
    ModalMode[ModalMode["Upload"] = 2] = "Upload";
})(ModalMode || (ModalMode = {}));
const DoctorEditPregnancy = () => {
    const [modalMode, setModalMode] = useState(ModalMode.Closed);
    const [idForModal, setIdForModal] = useState();
    const navigate = useRouteNavigate();
    const showToast = useShowToast();
    const handleDeletePress = (id) => {
        setIdForModal(id);
        setModalMode(ModalMode.Delete);
    };
    const handleClose = () => {
        setModalMode(ModalMode.Closed);
        setIdForModal(undefined);
    };
    const [editPregnancy] = useUpsertPregnancyMutation();
    const triggerEdit = (editData) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const transformedEditData = {
            patientId: editData.patientId,
            expectedAt: editData === null || editData === void 0 ? void 0 : editData.expectedAt,
            twinMethod: editData === null || editData === void 0 ? void 0 : editData.twinPregnancyMethod,
            twinPregnancyComment: (_a = editData === null || editData === void 0 ? void 0 : editData.twinPregnancyComment) !== null && _a !== void 0 ? _a : undefined,
            genderMethod: editData === null || editData === void 0 ? void 0 : editData.genderMethod,
            infantComment: (_b = editData.infantComment) !== null && _b !== void 0 ? _b : undefined,
            isHighRisk: (editData === null || editData === void 0 ? void 0 : editData.isHighRisk) ? true : false,
            infants: editData === null || editData === void 0 ? void 0 : editData.infants,
        };
        try {
            const data = yield editPregnancy(transformedEditData);
            if (data) {
                showToast("Sikeres mentés", { variant: "success" });
                navigate("patient", {
                    patientId: editData.patientId,
                });
            }
            else {
                showToast("A mentés nem sikerült", { variant: "error" });
            }
        }
        catch (error) {
            showToast("A mentés nem sikerült", { variant: "error" });
        }
    });
    return (_jsxs(PregnancyDataProviderWrapper, { children: [_jsx(PregnancyDoctorEditBreadcrumbs, {}), _jsx(PregnancyDoctorEdit, { uploadDocuments: () => setModalMode(ModalMode.Upload), handleDeletePress: handleDeletePress, 
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                triggerEdit: triggerEdit }), _jsx(DeleteDocumentDialog, { id: idForModal, open: modalMode === ModalMode.Delete, onClose: handleClose }), _jsx(UploadPregnancyDocModal, { open: modalMode === ModalMode.Upload, onClose: handleClose })] }));
};
export default DoctorEditPregnancy;
